<template lang="html">
  <div class="search-dropdown-wrapper" :class="{ blackClass: blackDiv }">
    <input
      @keyup.enter="searchMethod()"
      v-model="search"
      ref="searchInput"
      :placeholder="$t('nav.search')"
      type="text"
      name=""
      value=""
    />
    <img
      v-if="!blackDiv"
      @click="searchMethod()"
      src="@/assets/icons/magnifier.png"
      alt="magnifier icon"
    />
    <img
      v-else
      @click="searchMethod()"
      src="@/assets/icons/whiteMagnifier.png"
      alt="magnifier icon"
    />
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'searchDropdown',
  props: {
    blackDiv: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search: ''
    }
  },
  methods: {
    searchMethod () {
      if (this.search === '') {
        return
      }
      this.$emit('search')
      const query = {
        search: this.search
      }
      if (this.$route.name === 'Result') {
        eventBus.$emit('updateSearch', this.search)
      } else {
        this.$router.push({
          name: 'Result',
          params: this.$route.params,
          query: query
        })
      }
    }
  },
  watch: {
    $route: function (newVal, oldVal) {
      if (newVal.name !== 'Result') {
        this.search = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-dropdown-wrapper {
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  input {
    border: none;
    border-bottom: 1px solid #ddd;
    flex-grow: 1;
    height: 20px;
    line-height: 20px;
    padding-right: 20px;
    font-weight: bold;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.02em;
    color: $text-color;
    max-width: 230px;
  }
  input::placeholder {
    font-weight: bold;
    font-size: 13px;
    letter-spacing: 0.04em;
    color: $text-color;
  }
  input:focus {
    outline: none;
  }
  img {
    position: absolute;
    right: 0;
    cursor: pointer;
  }
}
.blackClass {
  background: #3f3f41;
  position: relative;
  margin-right: 15px;
  input {
    background: #3f3f41;
    border: none;
    border-bottom: 1px solid #ddd;
    flex-grow: 1;
    height: 20px;
    line-height: 20px;
    padding-right: 20px;
    font-weight: bold;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.02em;
    color: white;
    max-width: 230px;
  }
  input::placeholder {
    font-weight: bold;
    font-size: 13px;
    letter-spacing: 0.04em;
    color: #ddd;
  }
  input:focus {
    outline: none;
  }
  img {
    position: absolute;
    right: 13px;
    cursor: pointer;
  }
}
</style>
